export default [{
  key: 'display',
  label: 'Afficher si'
}, {
  key: 'hide',
  label: 'Masquer si'
}];
